import React from "react";
import { useTranslation } from "react-i18next";
import ClientesNavTree from "../shared/ClientesNavTree";
import {
  getLogisticaEnvioPedidosCount,
  getLogisticaEnvioTreeLabel,
  groupLogisticaEnviosByArticulo,
} from "./logisticaUtils";

const mapEnvioLeaf = (envio) => ({
  id: Number(envio?.IdLogisticaEnvio),
  label: getLogisticaEnvioTreeLabel(envio),
  count: getLogisticaEnvioPedidosCount(envio),
  closed: Boolean(envio?.IsClosed),
});

const LogisticaEnviosTree = ({
  groups = [],
  selectedEnvioId,
  onSelectEnvio,
}) => {
  const { t } = useTranslation();
  const articleLabels = {
    variosArticulos: t("logisticaPedidos.treeVariosArticulos"),
    sinArticulo: t("logisticaPedidos.treeSinArticulo"),
  };

  const mapped = (groups || []).map((group) => {
    const articulos =
      group.articulos ||
      groupLogisticaEnviosByArticulo(group.envios || [], articleLabels);
    return {
      key: group.key,
      label: group.label,
      items: articulos.map((art) => ({
        key: `${group.key}::${art.key}`,
        label: art.label,
        count: (art.envios || []).length,
        items: (art.envios || []).map(mapEnvioLeaf).filter((item) => item.id),
      })),
    };
  });

  return (
    <ClientesNavTree
      groups={mapped}
      selectedId={selectedEnvioId}
      onSelect={onSelectEnvio}
      title={t("logisticaPedidos.treeClientes")}
      countTooltip={(count) => t("logisticaPedidos.treePedidos", { count })}
      branchCountTooltip={(count) => t("logisticaPedidos.treeEnvios", { count })}
      closedLabel={t("logisticaPedidos.treeEntregado")}
      openLabel={t("logisticaPedidos.treePendiente")}
    />
  );
};

export default LogisticaEnviosTree;
